/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetPenaltiesDetailsQuery } from '../../models/get-penalties-details-query';
import { GetPenaltiesDetailsQueryResult } from '../../models/get-penalties-details-query-result';

export interface ApiPenaltyDetailsGetPenaltiesDetailsPost$Plain$Params {
      body?: GetPenaltiesDetailsQuery
}

export function apiPenaltyDetailsGetPenaltiesDetailsPost$Plain(http: HttpClient, rootUrl: string, params?: ApiPenaltyDetailsGetPenaltiesDetailsPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetPenaltiesDetailsQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiPenaltyDetailsGetPenaltiesDetailsPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetPenaltiesDetailsQueryResult>;
    })
  );
}

apiPenaltyDetailsGetPenaltiesDetailsPost$Plain.PATH = '/api/PenaltyDetails/GetPenaltiesDetails';
